import { render } from "./BuildingTypes.vue?vue&type=template&id=641c8af9"
import script from "./BuildingTypes.vue?vue&type=script&lang=js"
export * from "./BuildingTypes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__